import axiosInstance from './axios';

interface LoginRequest {
  username?: string;
  password?: string;
  token?: string;
  validateOnly?: boolean;
}

interface LoginResponse {
  token: string;
  user: {
    id: string;
    username: string;
    role: 'administrator' | 'guest' | 'user' | 'member';
  };
}

// LOGIN
export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  const response = await axiosInstance.post('/auth/login', credentials);
  return response.data;
};

export const createGuestSession = async (): Promise<LoginResponse> => {
  const response = await axiosInstance.post('/auth/guest');
  return response.data;
};

// PROFILE
export const getProfile = async (): Promise<LoginResponse['user']> => {
  const response = await axiosInstance.get('/auth/profile');
  return response.data;
};

// VALIDATE TOKEN
export const validateToken = async (): Promise<LoginResponse['user']> => {
  const response = await axiosInstance.get('/auth/profile');
  return response.data;
};

// UPDATE USER (ADMIN)
export const updateUser = async (user: {
  id: string;
  username?: string;
  password?: string;
  role?: string;
}): Promise<void> => {
  await axiosInstance.post('/auth/admin/update', user);
};

// DELETE USER (ADMIN)
export const deleteUser = async (id: string): Promise<void> => {
  await axiosInstance.post('/auth/admin/delete', { id });
};
